import i18next from 'i18next';
import { VEHICLES_TYPES, VEHICLES_AMOUNT, ROUTE_TYPES, CAPILLARITY, RESULT_CARDS } from 'constants/survey'

const otherCapillarity = {
  [CAPILLARITY.LOW]: {
    result: {
      ...RESULT_CARDS.NATIONAL
    }
  },
  [CAPILLARITY.HIGH]: {
    result: {
      ...RESULT_CARDS.REGIONAL
    }
  }
}

const otherRouteType = {
  [i18next.t(ROUTE_TYPES.INTERNATIONAL)]: {
    result: {
      ...RESULT_CARDS.EUROTRAFFIC
    }
  },
  [i18next.t(ROUTE_TYPES.NATIONAL)]: {
    result: {
      ...RESULT_CARDS.NATIONAL
    }
  },
  [i18next.t(ROUTE_TYPES.REGIONAL)]: {
    ...otherCapillarity
  },
  [i18next.t(ROUTE_TYPES.LAST_MILE)]: {
    ...otherCapillarity
  }
}

export const OTHER_FLOW = {
  [i18next.t(VEHICLES_TYPES.OTHER)]: {
    [VEHICLES_AMOUNT.ONE]: { ...otherRouteType },
    [VEHICLES_AMOUNT.TWO_FIVE]:  { ...otherRouteType },
    [VEHICLES_AMOUNT.SIX_TEN]: { ...otherRouteType },
    [VEHICLES_AMOUNT.ELEVEN_MORE]:  { ...otherRouteType }
  }
}
